import React from 'react'
import { Checkbox, NumericInput, Icon } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { useSegmentationPriorities } from '../../contexts/SegmentationPrioritiesProvider'

export function SegmentationScoresConstraints() {
  const {
    useRespondentsConstraint,
    setUseRespondentsConstraint,
    minRespondentsPerSegment,
    setMinRespondentsPerSegment,
    useDistributionConstraint,
    setUseDistributionConstraint,
    maxProperlyDistributedThreshold,
    setMaxProperlyDistributedThreshold,
    setNeedsRecalculationFlag,
  } = useSegmentationPriorities()

  // toggle helper for checkbox logic
  const handleToggle = (setter, value) => {
    setter(value)
    setNeedsRecalculationFlag(true)
  }

  return (
    <div className="constraints-section">
      <div className="constraint-group">
        <div className="constraint-label">
          <span>Minimum respondents per segment</span>{' '}
          <Tooltip2
            content="Only score segmentations where every segment has ≥ N respondents."
            placement="top"
          >
            <Icon
              icon="info-sign"
              intent="primary"
              aria-label="Help: minimum respondents constraint"
              size={10}
            />
          </Tooltip2>
        </div>
        <div className="constraint-row">
          <Checkbox
            checked={useRespondentsConstraint}
            onChange={e =>
              handleToggle(setUseRespondentsConstraint, e.target.checked)
            }
            label=""
          />
          <NumericInput
            placeholder="Minimum respondents"
            min={0}
            stepSize={10}
            minorStepSize={1}
            majorStepSize={50}
            defaultValue={minRespondentsPerSegment}
            onValueChange={value => {
              setMinRespondentsPerSegment(value)
              setNeedsRecalculationFlag(true)
            }}
            disabled={!useRespondentsConstraint}
          />
        </div>
      </div>
      <div className="constraint-group">
        <div className="constraint-label">
          <span>Properly distributed segments ratio</span>{' '}
          <Tooltip2
            content="Largest/smallest segment ratio must be < threshold (e.g., 2.5×)."
            placement="top"
          >
            <Icon
              icon="info-sign"
              intent="primary"
              aria-label="Help: distribution constraint"
              size={10}
            />
          </Tooltip2>
        </div>
        <div className="constraint-row">
          <Checkbox
            checked={useDistributionConstraint}
            onChange={e =>
              handleToggle(setUseDistributionConstraint, e.target.checked)
            }
            label=""
          />
          <NumericInput
            placeholder="Min threshold (e.g., 2.5)"
            min={1}
            stepSize={0.1}
            minorStepSize={0.1}
            majorStepSize={0.5}
            defaultValue={maxProperlyDistributedThreshold}
            clampValueOnBlur
            onValueChange={value => {
              setMaxProperlyDistributedThreshold(Math.max(1, value))
              setNeedsRecalculationFlag(true)
            }}
            disabled={!useDistributionConstraint}
          />
        </div>
      </div>
    </div>
  )
}
